var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56184 12.0009L11.7823 18.2199C11.9232 18.3608 12.0023 18.5518 12.0023 18.7509C12.0023 18.9501 11.9232 19.1411 11.7823 19.2819C11.6415 19.4228 11.4505 19.5019 11.2513 19.5019C11.0522 19.5019 10.8612 19.4228 10.7203 19.2819L3.97034 12.5319C3.9005 12.4623 3.84508 12.3795 3.80727 12.2884C3.76946 12.1973 3.75 12.0996 3.75 12.0009C3.75 11.9023 3.76946 11.8046 3.80727 11.7135C3.84508 11.6224 3.9005 11.5396 3.97034 11.4699L10.7203 4.71995C10.8612 4.57912 11.0522 4.5 11.2513 4.5C11.4505 4.5 11.6415 4.57912 11.7823 4.71995C11.9232 4.86078 12.0023 5.05178 12.0023 5.25095C12.0023 5.45011 11.9232 5.64112 11.7823 5.78195L5.56184 12.0009Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpBack);
export default __webpack_public_path__ + "static/media/ep_back.6f89b35dd99c28bdf71586a634501223.svg";
export { ForwardRef as ReactComponent };